import { render, staticRenderFns } from "./serviceProviderManage.vue?vue&type=template&id=25e717a3&scoped=true&"
import script from "./serviceProviderManage.vue?vue&type=script&lang=js&"
export * from "./serviceProviderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e717a3",
  null
  
)

export default component.exports